import type { Divisions } from "../const/config.const";
/**
 * Hook para obtener la division del usuario
 * @returns id de la division del usuario
 */
export const useDivision = (): Divisions | string => {
    let datoUsuarioDiv = JSON.parse(localStorage.getItem('userDiv'));
    let idDiv = datoUsuarioDiv.roleData.ID_DIVISION;
    return idDiv;
}